import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import {Link} from "react-router-dom";


export class AllianzAdvantagesBanner extends React.Component {

    public render() {

        const allianzAdvantagesBannerEnabled: boolean = process.env.REACT_APP_ALLIANZ_ADVANTAGES_BANNER_ENABLED
            ? JSON.parse(process.env.REACT_APP_ALLIANZ_ADVANTAGES_BANNER_ENABLED) : false;

        return (
            allianzAdvantagesBannerEnabled ?
                <div className="banner banner-content">
                    <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                    <div className="banner-text">
                        Don't forget to check out your latest offers and rewards in your new Allianz Advantages
                        area{'. '}
                        <p className="mt-3">
                            <Link
                                className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                                to={{pathname: `/dashboard/advantages`}}>
                                &rarr; View my Allianz Advantages
                            </Link>
                        </p>
                    </div>
                </div> : <></>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/AllianzAdvantagesBanner.tsx